var map = {
	"./battery-desktop.jpg": 767,
	"./battery-mobile.jpg": 3372,
	"./cover-desktop.jpg": 4454,
	"./cover-mobile.jpg": 3974,
	"./efficiency-desktop.jpg": 8703,
	"./efficiency-mobile.jpg": 2911,
	"./electricity-desktop.jpg": 5735,
	"./electricity-mobile.jpg": 9706,
	"./panels-about-desktop.jpg": 5294,
	"./panels-about-mobile.jpg": 5011,
	"./panels-control.jpg": 6756,
	"./panels-hero-desktop.jpg": 171,
	"./panels-hero-mobile.jpg": 2761,
	"./panels-protection.mp4": 7514,
	"./panels-specs.jpg": 102,
	"./roof-about-desktop.jpg": 4014,
	"./roof-about-mobile.jpg": 8143,
	"./roof-control.jpg": 4879,
	"./roof-hero-desktop.jpg": 1880,
	"./roof-hero-mobile.jpg": 69,
	"./roof-protection.mp4": 4807,
	"./roof-specs.jpg": 4003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7231;